export enum PaymentStatus {
	PENDING = 'PENDING',
	PAID = 'PAID',
	EXPIRED = 'EXPIRED',
	FAILED = 'FAILED'
}

export type PaymentMethod = 'PIX' | 'CARD';

export interface Payment {
	paymentId: string;
	method?: PaymentMethod;
	amountBRL: number;
	credits: number;
	feeBRL?: number;
	maxInstallments?: number;
	status: PaymentStatus;
	pixQrCode?: string;
	pixCopiaECola?: string;
	checkoutUrl?: string;
	createdAt?: string;
}

// Cotação do cartão (GET /payments/card/quote): total com a taxa embutida.
export interface CardQuote {
	credits: number;
	amountBRL: number;
	feeBRL: number;
	cardPct: number;
	cardFixedBRL: number;
	maxInstallments: number;
}
